import type { RouteRecordRaw } from 'vue-router'

function Layout() {
  return import('@/layouts/index.vue')
}

const routes: RouteRecordRaw = {
  path: '/settings',
  component: Layout,
  name: 'Settings',
  meta: {
    title: '设置',
    icon: 'i-ant-design:setting-outlined',
    auth: [],
    menuFlatten: true,
    breadcrumb: false,
  },
  children: [
    {
      path: 'appearance',
      name: 'SettingsAppearance',
      component: () => import('@/views/settings/appearance/index.vue'),
      meta: {
        title: '界面',
        icon: 'i-ant-design:bg-colors-outlined',
        auth: [],
      },
    },
    {
      path: 'security',
      name: 'SettingsSecurity',
      component: () => import('@/views/settings/security/index.vue'),
      meta: {
        title: '安全',
        icon: 'i-ant-design:safety-certificate-outlined',
        auth: [],
      },
    },
  ],
}

export default routes
